import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { fetchMatrixs } from '../actions/matrixs';
import { fetchCustomerPDA } from '../actions/customers';
import { fetchRentals } from '../actions/rentals';
import { fetchMachines } from '../actions/machines'

import { Bar, Line } from 'react-chartjs-2';

class OcupationDetailedView extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-indexed: 0=Jan, 7=Aug, etc.
    // If month is less than August (i.e. 0-6), default is previous year-current year.
    const defaultSelectedYearRange = currentMonth < 7
      ? `${currentYear - 1}-${currentYear}`
      : `${currentYear}-${currentYear + 1}`;

    this.state = {
      loading: true,
      error: null,
      rentalsData: null,
      selectedYearRange: defaultSelectedYearRange,
      // UI controls for zones KPI
      zonesSortBy: 'Hoy', // 'Hoy' or 'Promedio'
      zonesMinLockers: 0,
      selectedZoneForTrend: null,
      showHelp: false,
      // Chart view controls
      chartView: 'type', // 'type', 'zone', 'lockerType'
      chartScaleMode: 'auto', // 'auto' (based on data) or 'full' (based on total lockers)
      // Period mode: 'season', 'year', or 'custom'
      periodMode: 'season', // 'season' (Aug-Jul), 'year' (Jan-Dec), or 'custom' (date range)
      selectedYear: currentYear, // For full year mode
      customStartDate: `${currentYear}-01-01`, // For custom mode
      customEndDate: `${currentYear}-12-31`, // For custom mode
      // Loading progress tracking
      loadingProgress: {
        matrixs: false,
        rentals: false,
        machines: false
      },
      // Store the requested date range for chart rendering
      requestedDateRange: {
        startDate: null,
        endDate: null
      }
    };
    
    // Bind handlers in constructor to prevent creating new functions on each render
    this.handleCustomStartDateChange = this.handleCustomStartDateChange.bind(this);
    this.handleCustomEndDateChange = this.handleCustomEndDateChange.bind(this);
    this.handleCustomDateApply = this.handleCustomDateApply.bind(this);
  }

  componentDidMount() {
    const { type, id, role } = this.props;
    const { selectedYearRange } = this.state;
    const { startDate, endDate } = this.computeYearRangeDates(selectedYearRange);

    if (type === 'PDA') {
      this.props.fetchCustomerPDA(id)
        .then(response => this.fetchAllData(startDate, endDate, response.response.Customer))
        .catch(error => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else if (role === 'CUSTOMER') {
      this.fetchAllData(startDate, endDate, id);
    } else {
      this.fetchAllData(startDate, endDate, '');
    }
  }

  computeYearRangeDates = (yearRange, mode = null) => {
    const currentMode = mode || this.state.periodMode;
    
    if (currentMode === 'custom') {
      // Custom date range mode
      return {
        startDate: this.state.customStartDate,
        endDate: this.state.customEndDate,
      };
    } else if (currentMode === 'year') {
      // Full year mode: January 1st to December 31st
      const year = parseInt(yearRange);
      const startDate = `${year}-01-01`;
      const endDate = `${year}-12-31`;
      return { startDate, endDate };
    } else {
      // Season mode: August 1st to July 31st
      const [startYear, endYear] = yearRange.split('-').map(Number);
      const startDate = `${startYear}-08-01`;
      const endDate = `${endYear}-07-31`;
      return { startDate, endDate };
    }
  }

  // Helper to generate an array of full years starting from 2024
  generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const options = [];
    for (let year = 2024; year <= currentYear; year++) {
      options.push(year);
    }
    return options;
  }

  // Helper to generate an array of year ranges starting from 2024 up to the current year.
  generateYearRangeOptions = () => {
    const currentYear = new Date().getFullYear()
    const options = []
    for (let year = 2024; year <= currentYear; year++) {
      options.push(`${year}-${year + 1}`)
    }
    return options
  }

  handleYearRangeChange = (e) => {
    const { role, type, id } = this.props;
    const selectedYearRange = e.target.value;
    this.setState({ selectedYearRange });
    const { startDate, endDate } = this.computeYearRangeDates(selectedYearRange);
    // Use new fetchAll helper
    if (type === 'PDA') {
      this.props.fetchCustomerPDA(id)
        .then(response => this.fetchAllData(startDate, endDate, response.response.Customer))
        .catch(error => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else if (role === 'CUSTOMER') {
      this.fetchAllData(startDate, endDate, id);
    } else {
      this.fetchAllData(startDate, endDate, '');
    }
  }

  handlePeriodModeChange = (newMode) => {
    const { role, type, id } = this.props;
    this.setState({ periodMode: newMode });
    
    let startDate, endDate;
    if (newMode === 'custom') {
      // Switch to custom mode - use customStartDate and customEndDate
      startDate = this.state.customStartDate;
      endDate = this.state.customEndDate;
    } else if (newMode === 'year') {
      // Switch to year mode - use selectedYear
      const yearStr = this.state.selectedYear.toString();
      const dates = this.computeYearRangeDates(yearStr, 'year');
      startDate = dates.startDate;
      endDate = dates.endDate;
    } else {
      // Switch to season mode - use selectedYearRange
      const dates = this.computeYearRangeDates(this.state.selectedYearRange, 'season');
      startDate = dates.startDate;
      endDate = dates.endDate;
    }

    // Fetch data with new dates
    if (type === 'PDA') {
      this.props.fetchCustomerPDA(id)
        .then(response => this.fetchAllData(startDate, endDate, response.response.Customer))
        .catch(error => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else if (role === 'CUSTOMER') {
      this.fetchAllData(startDate, endDate, id);
    } else {
      this.fetchAllData(startDate, endDate, '');
    }
  }

  handleYearChange = (e) => {
    const { role, type, id } = this.props;
    const selectedYear = parseInt(e.target.value);
    this.setState({ selectedYear });
    const { startDate, endDate } = this.computeYearRangeDates(selectedYear.toString(), 'year');
    
    // Fetch data
    if (type === 'PDA') {
      this.props.fetchCustomerPDA(id)
        .then(response => this.fetchAllData(startDate, endDate, response.response.Customer))
        .catch(error => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else if (role === 'CUSTOMER') {
      this.fetchAllData(startDate, endDate, id);
    } else {
      this.fetchAllData(startDate, endDate, '');
    }
  }

  handleCustomDateChange = (field, value) => {
    // Only update state if value actually changed to avoid unnecessary re-renders
    if (this.state[field] !== value) {
      this.setState({ [field]: value });
    }
  }

  handleCustomStartDateChange = (e) => {
    const value = e.target.value;
    if (this.state.customStartDate !== value) {
      this.setState({ customStartDate: value });
    }
  }

  handleCustomEndDateChange = (e) => {
    const value = e.target.value;
    if (this.state.customEndDate !== value) {
      this.setState({ customEndDate: value });
    }
  }

  handleCustomDateApply = () => {
    const { role, type, id } = this.props;
    const { customStartDate, customEndDate } = this.state;
    
    // Validate dates before fetching
    if (!customStartDate || !customEndDate) {
      alert('Por favor selecciona ambas fechas');
      return;
    }
    
    if (!moment(customStartDate).isSameOrBefore(moment(customEndDate))) {
      alert('La fecha de inicio debe ser anterior o igual a la fecha de fin');
      return;
    }
    
    // Fetch data with custom dates
    if (type === 'PDA') {
      this.props.fetchCustomerPDA(id)
        .then(response => this.fetchAllData(customStartDate, customEndDate, response.response.Customer))
        .catch(error => {
          console.error('Error fetching customer PDA:', error);
          this.setState({ error: 'Failed to fetch customer PDA', loading: false });
        });
    } else if (role === 'CUSTOMER') {
      this.fetchAllData(customStartDate, customEndDate, id);
    } else {
      this.fetchAllData(customStartDate, customEndDate, '');
    }
  }

  // Centralized fetch helper to avoid duplicated fetch chains
  fetchAllData = (startDate, endDate, customer) => {
    this.setState({ 
      loading: true, 
      error: null,
      loadingProgress: { matrixs: false, rentals: false, machines: false },
      requestedDateRange: { startDate, endDate }
    });
    return this.props.fetchMatrixs('', '', customer, '')
      .then(() => {
        this.setState(prev => ({
          loadingProgress: { ...prev.loadingProgress, matrixs: true }
        }));
        return this.props.fetchRentals(undefined, undefined, startDate, endDate, customer);
      })
      .then(() => {
        this.setState(prev => ({
          loadingProgress: { ...prev.loadingProgress, rentals: true }
        }));
        return this.props.fetchMachines();
      })
      .then(() => {
        this.setState(prev => ({
          loadingProgress: { ...prev.loadingProgress, machines: true }
        }));
        // Pass the date range directly to processRentalsData
        this.processRentalsData(startDate, endDate);
        this.setState({ loading: false });
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        this.setState({ error: 'Failed to fetch data', loading: false });
      });
  }

  // Heuristic: find the best matching matrix for a rental when rental.Machine is missing or has no zone
  findMatrixForRental(rental, matrixs, machineMap = {}) {
    if (!rental || !Array.isArray(rental.LockerMatricula) || !matrixs) return null;
    let best = {};
    rental.LockerMatricula.forEach(idxStr => {
      const idxNum = parseInt(idxStr, 10);
      matrixs.forEach(matrix => {
        if (!matrix || !Array.isArray(matrix.Locker)) return;
        // Get FirstIndex from machine (machines array) since matrix may not have it
        const machine = machineMap[matrix.Serial];
        const firstIndex = (machine && Number(machine.FirstIndex)) || Number(matrix.FirstIndex) || 1;
        const localIndex = idxNum - firstIndex;
        if (localIndex >= 0 && localIndex < matrix.Locker.length) {
          // increase match count for this matrix
          best[matrix.Serial] = (best[matrix.Serial] || 0) + 1;
        }
      });
    });
    // pick matrix with highest count
    let bestSerial = null;
    let bestCount = 0;
    Object.keys(best).forEach(key => {
      if (best[key] > bestCount) { bestCount = best[key]; bestSerial = key; }
    });
    if (!bestSerial) return null;
    return matrixs.find(m => m.Serial === bestSerial) || null;
  }

  progressBar(actual, objective) {

    const percentage = Math.min((actual / objective) * 100, 100);

    let color = "bg-warning"

    if (percentage < 50) {
      color = "bg-success"
    } else if (percentage > 80) {
      color = "bg-danger"
    }

    return (
      <div className="progress-container">
        <div className={`progress-bar ${color}`} style={{ width: `${percentage}%` }}></div>
        <div className="progress-percentage">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  processRentalsData(requestedStartDate, requestedEndDate) {
    const { rentals, matrixs } = this.props;

    if (!rentals || !matrixs) return;

    const totalLockers = matrixs.reduce((sum, matrix) => {
      if (matrix.Locker && Array.isArray(matrix.Locker)) {
        return sum + matrix.Locker.length;
      }
      return sum;
    }, 0);

    // Filter out canceled rentals
    const validRentals = rentals.filter(rental => (rental.Status !== 'CANCELED' && rental.Status !== 'PRERENT' && rental.Type !== 'COUNTERINVOICE'));

    // Parse rentals data
    const rentalsByDate = {};
    validRentals.forEach((rental) => {
      const { StartDate, FinishDate, LockerMatricula } = rental;
      const startDate = moment(StartDate);
      const finishDate = moment(FinishDate);
      const days = finishDate.diff(startDate, 'days') + 1; // Include start and end date

      for (let i = 0; i < days; i++) {
        const currentDate = startDate.clone().add(i, 'days').format('YYYY-MM-DD');
        rentalsByDate[currentDate] = (rentalsByDate[currentDate] || 0) + LockerMatricula.length;
      }
    });

    // Determine which dates to use based on periodMode
    let startDate, endDate;
    const { periodMode } = this.state;
    
    if ((periodMode === 'year' || periodMode === 'custom') && requestedStartDate && requestedEndDate) {
      // For 'year' and 'custom' modes: use the exact requested date range
      // But limit to dates that have actual rental activity
      const requestedStart = moment(requestedStartDate);
      const requestedEnd = moment(requestedEndDate);
      const sortedDates = Object.keys(rentalsByDate).sort();
      
      if (sortedDates.length > 0) {
        const actualStart = moment(sortedDates[0]);
        const actualEnd = moment(sortedDates[sortedDates.length - 1]);
        
        // Use the intersection of requested range and actual rental dates
        startDate = moment.max(requestedStart, actualStart);
        endDate = moment.min(requestedEnd, actualEnd);
      } else {
        // No rentals in this period, use requested range but data will be empty
        startDate = requestedStart;
        endDate = requestedEnd;
      }
    } else {
      // For 'season' mode: use actual first and last day of rentals
      const sortedDates = Object.keys(rentalsByDate).sort();
      if (sortedDates.length === 0) return;
      startDate = moment(sortedDates[0]);
      endDate = moment(sortedDates[sortedDates.length - 1]);
    }

    // Generate data points for graph using the determined date range
    const dailyData = [];
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'days')) {
      const currentDate = date.format('YYYY-MM-DD');
      dailyData.push({
        date: currentDate,
        rented: rentalsByDate[currentDate] || 0,
        total: totalLockers,
      });
    }

    this.setState({ rentalsData: dailyData });
  }

  // Compute average occupation metrics over the current rentalsData period
  computeAverageOccupation() {
    const { rentalsData } = this.state;
    const { rentals } = this.props;
    
    if (!rentalsData || rentalsData.length === 0) {
      return {
        averageDailyRented: 0,
        averageOccupationPercent: 0,
        totalLockerDaysRented: 0,
        numberOfDays: 0,
        startDate: null,
        endDate: null,
        peakDay: null,
        peakDayRented: 0,
      };
    }

    // Find actual start and end dates from rentals
    let startDate = null;
    let endDate = null;
    
    if (rentals && Array.isArray(rentals)) {
      const validRentals = rentals.filter(rental =>
        rental.Status !== 'CANCELED' &&
        rental.Status !== 'PRERENT' &&
        ((rental.Type || '').trim().toUpperCase() !== 'COUNTERINVOICE')
      );
      
      validRentals.forEach(rental => {
        if (rental.StartDate) {
          const start = moment(rental.StartDate);
          if (!startDate || start.isBefore(startDate)) {
            startDate = start;
          }
        }
        if (rental.FinishDate) {
          const finish = moment(rental.FinishDate);
          if (!endDate || finish.isAfter(endDate)) {
            endDate = finish;
          }
        }
      });
    }

    // Find peak day (day with most rented lockers)
    let peakDay = null;
    let peakDayRented = 0;
    rentalsData.forEach(dayData => {
      if (dayData.rented > peakDayRented) {
        peakDayRented = dayData.rented;
        peakDay = dayData.date;
      }
    });

    const numberOfDays = rentalsData.length;
    const totalLockerDaysRented = rentalsData.reduce((sum, d) => sum + (d.rented || 0), 0);
    const averageDailyRented = totalLockerDaysRented / numberOfDays;
    const totalLockers = rentalsData[0].total || 0;
    const averageOccupationPercent = totalLockers > 0 ? (averageDailyRented / totalLockers) * 100 : 0;

    return {
      averageDailyRented,
      averageOccupationPercent,
      totalLockerDaysRented,
      numberOfDays,
      startDate: startDate ? startDate.format('DD/MM/YYYY') : null,
      endDate: endDate ? endDate.format('DD/MM/YYYY') : null,
      peakDay: peakDay ? moment(peakDay, 'YYYY-MM-DD').format('DD/MM/YYYY') : null,
      peakDayRented,
    };
  }
  renderChart() {
    const { rentalsData } = this.state;
    const { rentals } = this.props;

    if (!rentalsData || !rentals) return null;

    // Filter rentals to exclude unwanted types and statuses
    const validRentals = rentals.filter(rental =>
      rental.Status !== 'CANCELED' &&
      rental.Status !== 'PRERENT' &&
      ((rental.Type || '').trim().toUpperCase() !== 'COUNTERINVOICE')
    );

    // Define the fixed order for rental types
    const fixedTypeOrder = ['SEASON', 'WHITELIST', 'RENTAL', 'COLLECT', 'OTHER'];
    const types = fixedTypeOrder.filter(type =>
      validRentals.some(rental => ((rental.Type || '').trim().toUpperCase() === type))
    );

    // Group rentals by type and date
    const rentalsByDateAndType = {};
    validRentals.forEach(rental => {
      const { StartDate, FinishDate, Type, LockerMatricula } = rental;
      const normalizedType = ((Type || '').trim().toUpperCase()) || 'OTHER';
      const lockerCount = (LockerMatricula && LockerMatricula.length) || 1;
      const startDate = moment(StartDate);
      const finishDate = moment(FinishDate);
      const days = finishDate.diff(startDate, 'days') + 1;

      for (let i = 0; i < days; i++) {
        const currentDate = startDate.clone().add(i, 'days').format('YYYY-MM-DD');
        if (!rentalsByDateAndType[currentDate]) {
          rentalsByDateAndType[currentDate] = {};
        }
        rentalsByDateAndType[currentDate][normalizedType] =
          (rentalsByDateAndType[currentDate][normalizedType] || 0) + lockerCount;
      }
    });

    // Generate datasets for each type in the fixed order
    const labels = rentalsData.map(data => data.date);
    const datasets = types.map(type => ({
      label: type,
      data: labels.map(label => rentalsByDateAndType[label]?.[type] || 0),
      backgroundColor: {
        RENTAL: 'rgba(255,162,0,1)',
        SEASON: 'rgba(0,85,255,1)',
        WHITELIST: 'rgba(131,131,131,1)',
        COLLECT: 'rgba(3,168,30,1)',
        OTHER: 'rgba(198,12,198,1)',
      }[type] || 'rgba(150,150,150,1)',
    }));

    const totalLockers = rentalsData.length > 0 ? rentalsData[0].total : 1; // Avoid division by zero
    
    // Calculate max value from actual data for better scaling
    const maxRentedInData = Math.max(...labels.map((date, i) => 
      datasets.reduce((sum, dataset) => sum + dataset.data[i], 0)
    ));
    
    // Use auto scale or full scale based on chartScaleMode
    const yAxisMax = this.state.chartScaleMode === 'auto' 
      ? Math.ceil(maxRentedInData * 1.1) // 10% padding above max
      : totalLockers;

    const chartData = {
      labels,
      datasets,
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0, // Disable animation
      },
      hover: {
        animationDuration: 0, // Disable animation on hover
      },
      responsiveAnimationDuration: 0, // Disable animation on resize
      scales: {
        xAxes: [
          {
            stacked: true,
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 0,
              callback: function (value) {
                // Show only the first day of each week
                return moment(value).isoWeekday() === 1 ? value : '';
              },
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            scaleLabel: {
              display: true,
              labelString: 'Taquillas Alquiladas',
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              max: yAxisMax,
              stepSize: Math.ceil(yAxisMax / 10),
            },
          },
        ],
      },
      legend: {
        display: true, // Enable the legend
        position: 'top', // Position it at the top
      },
      tooltips: {
        mode: 'label',
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index];
            return `${dataset.label}: ${value}`;
          },
        },
      },
    };

    return <Bar data={chartData} options={options} style={{ height: '700px' }} />;
  }

  // Render chart by zone/customer
  renderChartByZone() {
    const { rentalsData } = this.state;
    const { rentals, machines } = this.props;

    if (!rentalsData || !rentals || !machines) return null;

    const machineMap = machines.reduce((acc, machine) => {
      acc[machine.Serial] = machine;
      return acc;
    }, {});

    const validRentals = rentals.filter(rental =>
      rental.Status !== 'CANCELED' &&
      rental.Status !== 'PRERENT' &&
      ((rental.Type || '').trim().toUpperCase() !== 'COUNTERINVOICE')
    );

    // Get all zones
    const zonesSet = new Set();
    validRentals.forEach(rental => {
      let zone = null;
      if (rental.Machine && rental.Machine.Contract && rental.Machine.Contract.Zone !== undefined) {
        zone = rental.Machine.Contract.Zone;
      } else if (rental.Machine && rental.Machine.Serial) {
        const machineFromMap = machineMap[rental.Machine.Serial];
        if (machineFromMap && machineFromMap.Contract) {
          zone = machineFromMap.Contract.Zone;
        }
      }
      if (zone !== null) zonesSet.add(zone);
    });

    const zones = Array.from(zonesSet).sort((a, b) => a - b);
    const zoneNamesMap = this.buildZoneNamesMap();

    // Group rentals by zone and date
    const rentalsByDateAndZone = {};
    validRentals.forEach(rental => {
      const { StartDate, FinishDate, LockerMatricula } = rental;
      const lockerCount = (LockerMatricula && LockerMatricula.length) || 1;
      
      let zone = null;
      if (rental.Machine && rental.Machine.Contract && rental.Machine.Contract.Zone !== undefined) {
        zone = rental.Machine.Contract.Zone;
      } else if (rental.Machine && rental.Machine.Serial) {
        const machineFromMap = machineMap[rental.Machine.Serial];
        if (machineFromMap && machineFromMap.Contract) {
          zone = machineFromMap.Contract.Zone;
        }
      }

      if (zone === null) return;

      const startDate = moment(StartDate);
      const finishDate = moment(FinishDate);
      const days = finishDate.diff(startDate, 'days') + 1;

      for (let i = 0; i < days; i++) {
        const currentDate = startDate.clone().add(i, 'days').format('YYYY-MM-DD');
        if (!rentalsByDateAndZone[currentDate]) {
          rentalsByDateAndZone[currentDate] = {};
        }
        rentalsByDateAndZone[currentDate][zone] =
          (rentalsByDateAndZone[currentDate][zone] || 0) + lockerCount;
      }
    });

    const labels = rentalsData.map(data => data.date);
    const colors = [
      'rgba(102, 126, 234, 0.8)',
      'rgba(245, 87, 108, 0.8)',
      'rgba(79, 172, 254, 0.8)',
      'rgba(250, 112, 154, 0.8)',
      'rgba(168, 237, 234, 0.8)',
      'rgba(252, 182, 159, 0.8)',
      'rgba(142, 197, 252, 0.8)',
      'rgba(118, 75, 162, 0.8)',
    ];

    const datasets = zones.map((zone, idx) => ({
      label: this.getZoneName(zone, zoneNamesMap),
      data: labels.map(label => rentalsByDateAndZone[label]?.[zone] || 0),
      backgroundColor: colors[idx % colors.length],
    }));

    const maxRentedInData = Math.max(...labels.map((date, i) => 
      datasets.reduce((sum, dataset) => sum + dataset.data[i], 0)
    ));
    
    const totalLockers = rentalsData.length > 0 ? rentalsData[0].total : 1;
    const yAxisMax = this.state.chartScaleMode === 'auto' 
      ? Math.ceil(maxRentedInData * 1.1)
      : totalLockers;

    const chartData = { labels, datasets };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0,
      },
      hover: {
        animationDuration: 0,
      },
      responsiveAnimationDuration: 0,
      scales: {
        xAxes: [{
          stacked: true,
          ticks: {
            autoSkip: false,
            maxRotation: 45,
            minRotation: 0,
            callback: function (value) {
              return moment(value).isoWeekday() === 1 ? value : '';
            },
          },
        }],
        yAxes: [{
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: 'Taquillas Alquiladas',
          },
          ticks: {
            beginAtZero: true,
            min: 0,
            max: yAxisMax,
            stepSize: Math.ceil(yAxisMax / 10),
          },
        }],
      },
      legend: {
        display: true,
        position: 'top',
      },
      tooltips: {
        mode: 'label',
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index];
            return `${dataset.label}: ${value}`;
          },
        },
      },
    };

    return <Bar data={chartData} options={options} style={{ height: '700px' }} />;
  }

  // Render chart by locker type
  renderChartByLockerType() {
    const { rentalsData } = this.state;
    const { rentals } = this.props;

    if (!rentalsData || !rentals) return null;

    const validRentals = rentals.filter(rental =>
      rental.Status !== 'CANCELED' &&
      rental.Status !== 'PRERENT' &&
      ((rental.Type || '').trim().toUpperCase() !== 'COUNTERINVOICE')
    );

    // Get all locker types
    const lockerTypesSet = new Set();
    validRentals.forEach(rental => {
      const lockerType = rental.LockerType || 'Desconocido';
      lockerTypesSet.add(lockerType);
    });

    const lockerTypes = Array.from(lockerTypesSet).sort();

    // Group rentals by locker type and date
    const rentalsByDateAndType = {};
    validRentals.forEach(rental => {
      const { StartDate, FinishDate, LockerMatricula } = rental;
      const lockerType = rental.LockerType || 'Desconocido';
      const lockerCount = (LockerMatricula && LockerMatricula.length) || 1;
      const startDate = moment(StartDate);
      const finishDate = moment(FinishDate);
      const days = finishDate.diff(startDate, 'days') + 1;

      for (let i = 0; i < days; i++) {
        const currentDate = startDate.clone().add(i, 'days').format('YYYY-MM-DD');
        if (!rentalsByDateAndType[currentDate]) {
          rentalsByDateAndType[currentDate] = {};
        }
        rentalsByDateAndType[currentDate][lockerType] =
          (rentalsByDateAndType[currentDate][lockerType] || 0) + lockerCount;
      }
    });

    const labels = rentalsData.map(data => data.date);
    const colors = [
      'rgba(102, 126, 234, 0.8)',
      'rgba(245, 87, 108, 0.8)',
      'rgba(79, 172, 254, 0.8)',
      'rgba(250, 112, 154, 0.8)',
      'rgba(168, 237, 234, 0.8)',
      'rgba(252, 182, 159, 0.8)',
    ];

    const datasets = lockerTypes.map((type, idx) => ({
      label: this.getLockerName(type),
      data: labels.map(label => rentalsByDateAndType[label]?.[type] || 0),
      backgroundColor: colors[idx % colors.length],
    }));

    const maxRentedInData = Math.max(...labels.map((date, i) => 
      datasets.reduce((sum, dataset) => sum + dataset.data[i], 0)
    ));
    
    const totalLockers = rentalsData.length > 0 ? rentalsData[0].total : 1;
    const yAxisMax = this.state.chartScaleMode === 'auto' 
      ? Math.ceil(maxRentedInData * 1.1)
      : totalLockers;

    const chartData = { labels, datasets };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0,
      },
      hover: {
        animationDuration: 0,
      },
      responsiveAnimationDuration: 0,
      scales: {
        xAxes: [{
          stacked: true,
          ticks: {
            autoSkip: false,
            maxRotation: 45,
            minRotation: 0,
            callback: function (value) {
              return moment(value).isoWeekday() === 1 ? value : '';
            },
          },
        }],
        yAxes: [{
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: 'Taquillas Alquiladas',
          },
          ticks: {
            beginAtZero: true,
            min: 0,
            max: yAxisMax,
            stepSize: Math.ceil(yAxisMax / 10),
          },
        }],
      },
      legend: {
        display: true,
        position: 'top',
      },
      tooltips: {
        mode: 'label',
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index];
            return `${dataset.label}: ${value}`;
          },
        },
      },
    };

    return <Bar data={chartData} options={options} style={{ height: '700px' }} />;
  }

  calculateOccupation(matrixs) {
    let totalLockers = 0;
    let occupiedLockers = 0;

    matrixs.forEach((matrix) => {
      if (matrix.Locker && Array.isArray(matrix.Locker)) {
        totalLockers += matrix.Locker.length;
        occupiedLockers += matrix.Locker.filter((locker) => (locker.Status === 'RQ' || locker.Status === 'RK' || locker.Status === 'RM' || locker.Status === 'RP')).length;
      }
    });

    const occupationPercentage = totalLockers > 0 ? ((occupiedLockers / totalLockers) * 100).toFixed(2) : 0;

    return { totalLockers, occupiedLockers, occupationPercentage };
  }

  // Dynamic locker type name - uses LockerType from rentals (e.g., "3PAX", "2PAX")
  // or falls back to matrix-based type codes
  getLockerName(type) {
    // Common readable names for known types
    const knownTypes = {
      // PAX-based types (from rentals)
      '2PAX': '2 Equipos de esquí',
      '3PAX': '3 Equipos de esquí',
      '4PAX': '4 Equipos de esquí',
      '3PAXSS': '3 Equipos sin secado',
      // Legacy matrix-based types (fallback)
      'BNS': 'Standard',
      'CNS': 'Standard Carga',
      'BWS': 'Standard XL',
      'BNM': 'Medium',
      'CNM': 'Medium Carga',
      'BWM': 'Medium XL',
      'CWM': 'Medium Carga XL',
      'BNL': 'Large',
      'CNL': 'Large Carga',
      'BWL': 'Large XL',
      'CWL': 'Large Carga XL',
      'BNXL': 'Extra Large',
      'CNXL': 'Extra Large Carga',
      'BWXL': 'Extra Large XL',
      'CWXL': 'Extra Large Carga XL',
      'BN2XL': '2XL',
      'CN2XL': '2XL Carga',
      'BW2XL': '2XL Wide',
      'CW2XL': '2XL Carga Wide',
      'BN3XL': '2 Equipos de esquí',
      'CN3XL': '3 Equipos de esquí',
      'BW3XL': '4 Equipos de esquí',
      'CW3XL': '3 Equipos sin secado',
    };
    return knownTypes[type] || type || 'Desconocido';
  }

  renderTable(matrixs) {
    const lockerCounts = {}; // Tracks totals of each type
    const rentedCounts = {}; // Tracks "RQ" rented counts

    matrixs.forEach(matrix => {
      if (matrix.Locker && Array.isArray(matrix.Locker)) {
        matrix.Locker.forEach(locker => {
          const lockerType = `${locker.Mode}${locker.Wide}${locker.Type}`;

          // Increment total counts for this type
          lockerCounts[lockerType] = (lockerCounts[lockerType] || 0) + 1;

          // Increment rented ("RQ") counts for this type
          if (locker.Status === 'RQ' || locker.Status === 'RK' || locker.Status === 'RM' || locker.Status === 'RP') {
            rentedCounts[lockerType] = (rentedCounts[lockerType] || 0) + 1;
          }
        });
      }
    });

    // Define the reference order for sorting
    const lockerOrder = [
      "BNS", "CNS", "BWS",
      "BNM", "CNM", "BWM", "CWM",
      "BNL", "CNL", "BWL", "CWL",
      "BNXL", "CNXL", "BWXL", "CWXL",
      "BN2XL", "CN2XL", "BW2XL", "CW2XL",
      "BN3XL", "CN3XL", "BW3XL", "CW3XL"
    ];

    const rows = Object.entries(lockerCounts)
      .map(([type, totalCount]) => {
        const rentedCount = rentedCounts[type] || 0; // Default to 0 if no "RQ" rentals for this type
        return {
          type,
          lockerName: this.getLockerName(type),
          rentedCount,
          totalCount,
          percentage: ((rentedCount / totalCount) * 100).toFixed(2)
        };
      })
      .sort((a, b) => lockerOrder.indexOf(a.type) - lockerOrder.indexOf(b.type)) // Sort based on lockerOrder
      .map(({ type, lockerName, rentedCount, totalCount, percentage }) => (
        <tr key={type}>
          <td>{lockerName}</td>
          <td>{rentedCount}</td>
          <td>{totalCount}</td>
          <td>{this.progressBar(rentedCount, totalCount)}</td>
        </tr>
      ));

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Tipo de taquilla</th>
              <th scope="col">Alquiladas (hoy)</th>
              <th scope="col">Totales</th>
              <th scope="col">% Hoy</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }

  // Render locker types table based on rentals LockerType (e.g., "3PAX", "2PAX") with season averages
  renderLockerTypesByRentals() {
    const { rentals, matrixs } = this.props;
    
    if (!rentals || !matrixs) return null;

    const selectedRange = this.state.selectedYearRange;
    const { startDate: seasonStartStr, endDate: seasonEndStr } = this.computeYearRangeDates(selectedRange);
    const seasonStart = moment(seasonStartStr);
    const seasonEnd = moment(seasonEndStr);
    const today = moment();
    const avgPeriodEnd = seasonEnd.isAfter(today) ? today : seasonEnd;
    const avgPeriodStart = seasonStart;
    const numDays = avgPeriodEnd.diff(avgPeriodStart, 'days') + 1;

    // Filter valid rentals
    const validRentals = rentals.filter(rental =>
      rental.Status !== 'CANCELED' &&
      rental.Status !== 'PRERENT' &&
      ((rental.Type || '').trim().toUpperCase() !== 'COUNTERINVOICE')
    );

    // Build daily counts per LockerType
    const lockerTypeTotals = {}; // Total lockers available per type (from all rentals seen)
    const lockerTypeRentedDaily = {}; // { type: { day: count } }

    validRentals.forEach(rental => {
      const lockerType = rental.LockerType || 'Desconocido';
      const lockerCount = (rental.LockerMatricula && rental.LockerMatricula.length) || 0;
      if (lockerCount === 0) return;

      // Track this locker type
      if (!lockerTypeTotals[lockerType]) {
        lockerTypeTotals[lockerType] = 0;
        lockerTypeRentedDaily[lockerType] = {};
        for (let i = 0; i < numDays; i++) {
          const day = avgPeriodStart.clone().add(i, 'days').format('YYYY-MM-DD');
          lockerTypeRentedDaily[lockerType][day] = 0;
        }
      }

      // Add to daily counts
      const rentalStart = moment(rental.StartDate);
      const rentalEnd = moment(rental.FinishDate);
      const effectiveStart = moment.max(rentalStart, avgPeriodStart);
      const effectiveEnd = moment.min(rentalEnd, avgPeriodEnd);
      if (effectiveEnd.isSameOrAfter(effectiveStart)) {
        const daysOverlap = effectiveEnd.diff(effectiveStart, 'days') + 1;
        for (let i = 0; i < daysOverlap; i++) {
          const day = effectiveStart.clone().add(i, 'days').format('YYYY-MM-DD');
          if (lockerTypeRentedDaily[lockerType][day] !== undefined) {
            lockerTypeRentedDaily[lockerType][day] += lockerCount;
          }
        }
      }
    });

    // Compute totals from matrix for each locker type (if available)
    // Since matrix uses different type codes, we'll show rental-based stats only
    const rows = Object.keys(lockerTypeTotals).map(type => {
      const dailyCounts = Object.values(lockerTypeRentedDaily[type] || {});
      const totalRentedOverPeriod = dailyCounts.reduce((s, v) => s + (v || 0), 0);
      const averageRented = numDays > 0 ? (totalRentedOverPeriod / numDays) : 0;
      const maxDaily = Math.max(...dailyCounts, 0);

      return {
        type,
        typeName: this.getLockerName(type),
        averageRented,
        totalRentedOverPeriod,
        maxDaily,
      };
    }).sort((a, b) => b.averageRented - a.averageRented);

    const tableRows = rows.map(item => (
      <tr key={item.type}>
        <td>{item.typeName}</td>
        <td>{Math.round(item.averageRented * 100) / 100}</td>
        <td>{item.totalRentedOverPeriod}</td>
        <td>{item.maxDaily}</td>
      </tr>
    ));

    return (
      <div className="table-responsive">
        <table className="table table-hover table-clickable">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Tipo de taquilla</th>
              <th scope="col">Promedio diario</th>
              <th scope="col">Total locker-días</th>
              <th scope="col">Máximo diario</th>
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </table>
      </div>
    );
  }

  // Build a map of zone ID -> zone description from rentals and machines
  buildZoneNamesMap() {
    const { rentals, machines } = this.props;
    const zoneNames = {};

    // 1. Extract zone names from rentals -> Customer.Zones
    if (rentals && Array.isArray(rentals)) {
      rentals.forEach(rental => {
        if (rental.Customer && Array.isArray(rental.Customer.Zones)) {
          rental.Customer.Zones.forEach(z => {
            if (z.Zone !== undefined && z.Description) {
              zoneNames[z.Zone] = z.Description;
            }
          });
        }
      });
    }

    // 2. Fallback: extract zone names from machines -> Contract
    if (machines && Array.isArray(machines)) {
      machines.forEach(machine => {
        if (machine.Contract && machine.Contract.Zone !== undefined) {
          const zoneId = machine.Contract.Zone;
          if (!zoneNames[zoneId] && machine.Contract.Description) {
            zoneNames[zoneId] = machine.Contract.Description;
          }
          // If still no name, use Zone number as string
          if (!zoneNames[zoneId]) {
            zoneNames[zoneId] = `Zona ${zoneId}`;
          }
        }
      });
    }

    return zoneNames;
  }

  getZoneName(zone, zoneNamesMap = null) {
    const map = zoneNamesMap || this.buildZoneNamesMap();
    return map[zone] || `Zona ${zone}`;
  }

  renderZonesTable(matrixs, machines) {
    const { category, rentals } = this.props;

    if (!machines || !matrixs) return null;

    // Build machine lookup by serial
    const machineMap = machines.reduce((acc, machine) => {
      acc[machine.Serial] = machine;
      return acc;
    }, {});

    // Compute total lockers per zone from matrixs + machines
    const zoneTotals = {};
    matrixs.forEach(matrix => {
      const machine = machineMap[matrix.Serial];
      if (machine && machine.Contract) {
        const zone = machine.Contract.Zone;
        if (!zoneTotals[zone]) zoneTotals[zone] = 0;
        if (matrix.Locker && Array.isArray(matrix.Locker)) {
          zoneTotals[zone] += matrix.Locker.length;
        }
      }
    });

    // ACTUAL DAY: compute rented lockers per zone from current locker statuses
    const actualRentedByZone = {};
    Object.keys(zoneTotals).forEach(z => actualRentedByZone[z] = 0);
    matrixs.forEach(matrix => {
      const machine = machineMap[matrix.Serial];
      if (machine && machine.Contract && matrix.Locker && Array.isArray(matrix.Locker)) {
        const zone = machine.Contract.Zone;
        matrix.Locker.forEach(locker => {
          if (locker.Status === 'RQ' || locker.Status === 'RK' || locker.Status === 'RM' || locker.Status === 'RP') {
            actualRentedByZone[zone] = (actualRentedByZone[zone] || 0) + 1;
          }
        });
      }
    });

    // SEASON AVERAGE: compute average rented per zone from rentals
    // First, filter valid rentals to find the actual date range
    let validRentals = [];
    if (rentals && Array.isArray(rentals)) {
      validRentals = rentals.filter(rental =>
        rental.Status !== 'CANCELED' &&
        rental.Status !== 'PRERENT' &&
        ((rental.Type || '').trim().toUpperCase() !== 'COUNTERINVOICE')
      );
    }

    // Find the actual first and last rental dates
    let avgPeriodStart = null;
    let avgPeriodEnd = null;
    
    validRentals.forEach(rental => {
      if (rental.StartDate) {
        const startDate = moment(rental.StartDate);
        if (!avgPeriodStart || startDate.isBefore(avgPeriodStart)) {
          avgPeriodStart = startDate;
        }
      }
      if (rental.FinishDate) {
        const finishDate = moment(rental.FinishDate);
        if (!avgPeriodEnd || finishDate.isAfter(avgPeriodEnd)) {
          avgPeriodEnd = finishDate;
        }
      }
    });

    // Fallback to season dates if no rentals found
    if (!avgPeriodStart || !avgPeriodEnd) {
      const selectedRange = this.state.selectedYearRange;
      const { startDate: seasonStartStr, endDate: seasonEndStr } = this.computeYearRangeDates(selectedRange);
      avgPeriodStart = moment(seasonStartStr);
      avgPeriodEnd = moment(seasonEndStr);
    }

    const numDays = avgPeriodEnd.diff(avgPeriodStart, 'days') + 1;

    // Initialize daily counts per zone
    const zoneRentedDaily = {};
    Object.keys(zoneTotals).forEach(zone => {
      zoneRentedDaily[zone] = {};
      for (let i = 0; i < numDays; i++) {
        const day = avgPeriodStart.clone().add(i, 'days').format('YYYY-MM-DD');
        zoneRentedDaily[zone][day] = 0;
      }
    });

    if (validRentals.length > 0) {

      validRentals.forEach(rental => {
        if (!rental.LockerMatricula || rental.LockerMatricula.length === 0) return;

        // Determine zone from rental data
        let zone = null;
        
        // 1. Try rental.Machine.Contract.Zone directly (populated in your data)
        if (rental.Machine && rental.Machine.Contract && rental.Machine.Contract.Zone !== undefined) {
          zone = rental.Machine.Contract.Zone;
        }
        // 2. Fallback: look up machine from machines array using Serial
        else if (rental.Machine && rental.Machine.Serial) {
          const machineFromMap = machineMap[rental.Machine.Serial];
          if (machineFromMap && machineFromMap.Contract) {
            zone = machineFromMap.Contract.Zone;
          }
        }
        // 3. Last fallback: try to infer via matrix lookup
        if (zone === null) {
          const inferredMatrix = this.findMatrixForRental(rental, matrixs, machineMap);
          if (inferredMatrix) {
            const inferredMachine = machineMap[inferredMatrix.Serial];
            if (inferredMachine && inferredMachine.Contract) {
              zone = inferredMachine.Contract.Zone;
            }
          }
        }

        if (zone === null || zoneTotals[zone] === undefined) return; // skip unknown zone

        const rentalStart = moment(rental.StartDate);
        const rentalEnd = moment(rental.FinishDate);
        const effectiveStart = moment.max(rentalStart, avgPeriodStart);
        const effectiveEnd = moment.min(rentalEnd, avgPeriodEnd);
        if (effectiveEnd.isSameOrAfter(effectiveStart)) {
          const daysOverlap = effectiveEnd.diff(effectiveStart, 'days') + 1;
          for (let i = 0; i < daysOverlap; i++) {
            const day = effectiveStart.clone().add(i, 'days').format('YYYY-MM-DD');
            zoneRentedDaily[zone][day] += rental.LockerMatricula.length;
          }
        }
      });
    }

    // Build a sortable/filterable list of zones with both KPIs
    const zoneItems = Object.keys(zoneTotals).map(zone => {
      const totalLockers = zoneTotals[zone];
      const actualRented = actualRentedByZone[zone] || 0;
      const dailyCounts = Object.values(zoneRentedDaily[zone] || {});
      const totalRentedOverPeriod = dailyCounts.reduce((s, v) => s + (v || 0), 0);
      const averageRented = numDays > 0 ? (totalRentedOverPeriod / numDays) : 0;
      const actualPercent = totalLockers > 0 ? ((actualRented / totalLockers) * 100) : 0;
      const averagePercent = totalLockers > 0 ? ((averageRented / totalLockers) * 100) : 0;
      return {
        zone,
        totalLockers,
        actualRented,
        averageRented,
        actualPercent,
        averagePercent,
      };
    });

    // Apply min lockers filter
    const minLockers = Number(this.state.zonesMinLockers) || 0;
    let filtered = zoneItems.filter(z => z.totalLockers >= minLockers);

    // Apply sorting
    if (this.state.zonesSortBy === 'Hoy') {
      filtered.sort((a, b) => b.actualPercent - a.actualPercent);
    } else {
      filtered.sort((a, b) => b.averagePercent - a.averagePercent);
    }

    // Build zone names map once for this render
    const zoneNamesMap = this.buildZoneNamesMap();

    const rows = filtered.map(item => (
      <tr key={item.zone}>
        <td>{this.getZoneName(item.zone, zoneNamesMap)}</td>
        <td>{item.actualRented}</td>
        <td>{item.totalLockers}</td>
        <td style={{ minWidth: '140px' }}>{this.progressBar(item.actualRented, item.totalLockers)}</td>
        <td>{Math.round(item.averageRented * 100) / 100}</td>
        <td style={{ minWidth: '140px' }}>{this.progressBar(item.averageRented, item.totalLockers)}</td>
      </tr>
    ));

    // Compute totals for footer
    const totals = Object.keys(zoneTotals).reduce((acc, zone) => {
      const totalLockers = zoneTotals[zone];
      const actual = actualRentedByZone[zone] || 0;
      const dailyCounts = Object.values(zoneRentedDaily[zone] || {});
      const totalRentedOverPeriod = dailyCounts.reduce((s, v) => s + (v || 0), 0);
      acc.totalLockers += totalLockers;
      acc.totalActual += actual;
      acc.totalRentedOverPeriod += totalRentedOverPeriod;
      return acc;
    }, { totalLockers: 0, totalActual: 0, totalRentedOverPeriod: 0 });

    const averageRentedOverall = numDays > 0 ? (totals.totalRentedOverPeriod / numDays) : 0;

    // Prepare zone selector options for trend (use dynamic zone names)
    const zoneOptions = Object.keys(zoneTotals).map(z => ({ value: z, label: this.getZoneName(z, zoneNamesMap) }));

    // Trend chart for selected zone
    const selectedZone = this.state.selectedZoneForTrend || (zoneOptions.length > 0 ? zoneOptions[0].value : null);
    const trendLabels = [];
    const trendData = [];
    if (selectedZone && zoneRentedDaily[selectedZone]) {
      for (let i = 0; i < numDays; i++) {
        const day = avgPeriodStart.clone().add(i, 'days').format('YYYY-MM-DD');
        trendLabels.push(day);
        trendData.push(zoneRentedDaily[selectedZone][day] || 0);
      }
    }

    const trendChart = selectedZone ? (
      <div style={{ height: '250px' }} className="mb-3">
        <Line
          data={{ labels: trendLabels, datasets: [{ label: `Alquiladas por día - Zona ${selectedZone}`, data: trendData, fill: false, borderColor: 'rgba(75,192,192,1)' }] }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      </div>
    ) : null;

    return (
      <div>
        <div className="d-flex justify-content-between mb-2">
          <div className="d-flex align-items-center">
            <label className="mr-2">Ordenar por:</label>
            <select className="form-control mr-2" style={{ width: '140px' }} value={this.state.zonesSortBy} onChange={e => this.setState({ zonesSortBy: e.target.value })}>
              <option value="Hoy">Hoy</option>
              <option value="Promedio">Promedio</option>
            </select>
            <label className="mr-2">Min taquillas:</label>
            <input type="number" className="form-control" style={{ width: '80px' }} value={this.state.zonesMinLockers} onChange={e => this.setState({ zonesMinLockers: e.target.value })} />
          </div>
          <div className="d-flex align-items-center">
            <label className="mr-2">Zona (trend):</label>
            <select className="form-control mr-2" style={{ width: '180px' }} value={this.state.selectedZoneForTrend || (zoneOptions[0] && zoneOptions[0].value)} onChange={e => this.setState({ selectedZoneForTrend: e.target.value })}>
              {zoneOptions.map(z => <option key={z.value} value={z.value}>{z.label}</option>)}
            </select>
            <button className="btn btn-outline-secondary mr-2" onClick={() => this.setState({ showHelp: !this.state.showHelp })}>{this.state.showHelp ? 'Ocultar ayuda' : 'Ayuda'}</button>
            <button className="btn btn-outline-primary" onClick={() => this.exportZonesCsv(zoneTotals, actualRentedByZone, zoneRentedDaily, numDays)}>Exportar CSV</button>
          </div>
        </div>

        {this.state.showHelp && (
          <div className="alert alert-info">
            <strong>Ayuda:</strong> "Alquiladas (hoy)" muestra la ocupación actual basada en el estado de las taquillas. "Alquiladas (promedio)" muestra el promedio diario de taquillas alquiladas desde el inicio de la temporada hasta hoy (o hasta el fin de temporada si ya pasó). Los porcentajes son relativos al total de taquillas de la zona.
          </div>
        )}

        {trendChart}

        <div className="table-responsive">
          <table className="table table-hover table-clickable">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Zona</th>
                <th scope="col">Alquiladas (hoy)</th>
                <th scope="col">Totales</th>
                <th scope="col">% Hoy</th>
                <th scope="col">Alquiladas (promedio)</th>
                <th scope="col">% Promedio</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
            <tfoot>
              <tr>
                <th>Totales</th>
                <th>{totals.totalActual}</th>
                <th>{totals.totalLockers}</th>
                <th>{totals.totalLockers > 0 ? ((totals.totalActual / totals.totalLockers) * 100).toFixed(2) : '0.00'}%</th>
                <th>{Math.round(averageRentedOverall * 100) / 100}</th>
                <th>{totals.totalLockers > 0 ? ((averageRentedOverall / totals.totalLockers) * 100).toFixed(2) : '0.00'}%</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }

  exportZonesCsv(zoneTotals, actualRentedByZone, zoneRentedDaily, numDays) {
    const headers = ['Zone','ActualRented','TotalLockers','ActualPercent','AverageRented','AveragePercent'];
    const rows = Object.keys(zoneTotals).map(zone => {
      const totalLockers = zoneTotals[zone];
      const actual = actualRentedByZone[zone] || 0;
      const dailyCounts = Object.values(zoneRentedDaily[zone] || {});
      const totalRentedOverPeriod = dailyCounts.reduce((s, v) => s + (v || 0), 0);
      const averageRented = numDays > 0 ? (totalRentedOverPeriod / numDays) : 0;
      const actualPercent = totalLockers > 0 ? ((actual / totalLockers) * 100).toFixed(2) : '0.00';
      const averagePercent = totalLockers > 0 ? ((averageRented / totalLockers) * 100).toFixed(2) : '0.00';
      return [zone, actual, totalLockers, actualPercent, Math.round(averageRented*100)/100, averagePercent];
    });

    const csvContent = [headers, ...rows].map(r => r.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `zones_kpi_${new Date().toISOString().slice(0,10)}.csv`;
    document.body.appendChild(a);
    a.click();
    if (document.body.contains(a)) {
      document.body.removeChild(a);
    }
    try {
      URL.revokeObjectURL(url);
    } catch (e) {
      // ignore revoke errors
    }
  }

  render() {
    const { matrixs, loading, error, rentals, machines, category } = this.props;

    if (this.state.loading || !matrixs || !rentals || !machines) {
      // Compute progress based on which requests have finished
      const requests = [
        { name: 'Máquinas', done: this.state.loadingProgress.matrixs },
        { name: 'Alquileres', done: this.state.loadingProgress.rentals },
        { name: 'Dispositivos', done: this.state.loadingProgress.machines },
      ];
      const total = requests.length;
      const completed = requests.filter(r => r.done).length;
      const progress = Math.round((completed / total) * 100);

      return (
        <div className="kpi-loading min-vh-100 d-flex flex-column align-items-center justify-content-center">
          <img className="kpi-loading-logo" src="/images/logo_blue.png" alt="Logo" height={56} />

          {/* Progress bar */}
          <div
            className="kpi-progress"
            role="progressbar"
            aria-label="Cargando datos de ocupación"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={progress}
          >
            <div
              className="kpi-progress-fill"
              style={{ width: `${progress}%`, background: '#067ddb' }}
            />
          </div>

          <div className="kpi-progress-text" style={{ color: '#01315f' }}>{progress}%</div>
          
          {/* Show which step is loading */}
          <div style={{ marginTop: '12px', fontSize: '0.9rem', color: '#6b6b6b' }}>
            {requests.map((req, idx) => (
              <span key={req.name} style={{ marginRight: '16px' }}>
                {req.done ? '✓' : '⏳'} {req.name}
              </span>
            ))}
          </div>
        </div>
      );
    }

    if (error) {
      return <div className="alert alert-danger">{error}</div>;
    }

    const { totalLockers, occupiedLockers, occupationPercentage } = this.calculateOccupation(matrixs);
    const avgMetrics = this.computeAverageOccupation();
    const avgOccupationPercent = Number(avgMetrics.averageOccupationPercent).toFixed(2);
    const avgDailyRented = Math.round(avgMetrics.averageDailyRented * 100) / 100;
    const totalLockerDaysRented = avgMetrics.totalLockerDaysRented;
    const numberOfDays = avgMetrics.numberOfDays;
    const peakDay = avgMetrics.peakDay;
    const peakDayRented = avgMetrics.peakDayRented;
    const today = moment().format('DD/MM/YYYY HH:mm');

    return (
      <div>
        {/* Header with Season Selector */}
        <div className="row mb-4 align-items-center">
          <div className="col-xs-12 col-sm-6 col-md-6">
            <h1 style={{ fontSize: '2.5rem', fontWeight: '300', marginBottom: '0' }}>
              <span className="text-vw-dark" style={{ fontWeight: '600' }}>DASHBOARD</span>
              <span className="text-vw-light"> de Ocupación</span>
            </h1>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 text-right">
            <div className="d-flex justify-content-end align-items-center">
              {/* Period Mode Toggle */}
              <div className="btn-group mr-3" role="group">
                <button 
                  type="button" 
                  className="btn btn-sm"
                  onClick={() => this.handlePeriodModeChange('season')}
                  style={{ 
                    fontSize: '0.9rem', 
                    padding: '8px 16px',
                    backgroundColor: this.state.periodMode === 'season' ? '#01315f' : 'white',
                    color: this.state.periodMode === 'season' ? 'white' : '#01315f',
                    border: '2px solid #01315f'
                  }}
                >
                  🗓️ Temporada
                </button>
                <button 
                  type="button" 
                  className="btn btn-sm"
                  onClick={() => this.handlePeriodModeChange('year')}
                  style={{ 
                    fontSize: '0.9rem', 
                    padding: '8px 16px',
                    backgroundColor: this.state.periodMode === 'year' ? '#01315f' : 'white',
                    color: this.state.periodMode === 'year' ? 'white' : '#01315f',
                    border: '2px solid #01315f'
                  }}
                >
                  📅 Año Completo
                </button>
                <button 
                  type="button" 
                  className="btn btn-sm"
                  onClick={() => this.handlePeriodModeChange('custom')}
                  style={{ 
                    fontSize: '0.9rem', 
                    padding: '8px 16px',
                    backgroundColor: this.state.periodMode === 'custom' ? '#01315f' : 'white',
                    color: this.state.periodMode === 'custom' ? 'white' : '#01315f',
                    border: '2px solid #01315f'
                  }}
                >
                  📆 Personalizado
                </button>
              </div>
              
              {/* Conditional Selector based on mode */}
              {this.state.periodMode === 'season' ? (
                <select
                  value={this.state.selectedYearRange}
                  onChange={this.handleYearRangeChange}
                  style={{ 
                    fontSize: '1.1rem', 
                    padding: '10px', 
                    borderRadius: '8px', 
                    border: '2px solid #067ddb', 
                    width: 'auto', 
                    display: 'inline-block', 
                    minWidth: '200px',
                    color: '#01315f',
                    outline: 'none'
                  }}
                >
                  {this.generateYearRangeOptions().map(range => (
                    <option key={range} value={range}>Temporada {range}</option>
                  ))}
                </select>
              ) : this.state.periodMode === 'year' ? (
                <select
                  value={this.state.selectedYear}
                  onChange={this.handleYearChange}
                  style={{ 
                    fontSize: '1.1rem', 
                    padding: '10px', 
                    borderRadius: '8px', 
                    border: '2px solid #067ddb', 
                    width: 'auto', 
                    display: 'inline-block', 
                    minWidth: '150px',
                    color: '#01315f',
                    outline: 'none'
                  }}
                >
                  {this.generateYearOptions().map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              ) : (
                <div className="d-flex align-items-center">
                  <div className="mr-2">
                    <label style={{ fontSize: '0.85rem', marginBottom: '2px', display: 'block', color: '#6b6b6b' }}>Inicio</label>
                    <input
                      type="date"
                      value={this.state.customStartDate}
                      onChange={this.handleCustomStartDateChange}
                      style={{ 
                        fontSize: '0.95rem', 
                        padding: '8px', 
                        borderRadius: '8px', 
                        border: '2px solid #067ddb', 
                        width: '150px',
                        color: '#01315f',
                        outline: 'none'
                      }}
                    />
                  </div>
                  <div className="mr-2">
                    <label style={{ fontSize: '0.85rem', marginBottom: '2px', display: 'block', color: '#6b6b6b' }}>Fin</label>
                    <input
                      type="date"
                      value={this.state.customEndDate}
                      onChange={this.handleCustomEndDateChange}
                      style={{ 
                        fontSize: '0.95rem', 
                        padding: '8px', 
                        borderRadius: '8px', 
                        border: '2px solid #067ddb', 
                        width: '150px',
                        color: '#01315f',
                        outline: 'none'
                      }}
                    />
                  </div>
                  <div style={{ marginTop: '18px' }}>
                    <button
                      type="button"
                      className="btn btn-sm"
                      onClick={this.handleCustomDateApply}
                      style={{
                        fontSize: '0.95rem',
                        padding: '8px 20px',
                        borderRadius: '8px',
                        backgroundColor: '#067ddb',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: '600'
                      }}
                    >
                      ➤ Aplicar
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* KPI Cards - Instant Metrics */}
        <div className="mb-4">
          <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '20px', color: '#01315f' }}>
            📊 Métricas en Tiempo Real
            <small style={{ fontSize: '0.85rem', fontWeight: '400', marginLeft: '15px', color: '#6b6b6b' }}>Actualizado: {today}</small>
          </h3>
          <div className="row">
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #01315f 0%, #067ddb 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: 'white',
                boxShadow: '0 10px 30px rgba(1, 49, 95, 0.3)',
                transition: 'transform 0.3s ease',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.9', marginBottom: '8px', fontWeight: '500' }}>💼 Ocupación Actual</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1' }}>{occupationPercentage}%</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.8', marginTop: '10px' }}>Estado instantáneo</div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #067ddb 0%, #01315f 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: 'white',
                boxShadow: '0 10px 30px rgba(6, 125, 219, 0.3)',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.9', marginBottom: '8px', fontWeight: '500' }}>🔒 Taquillas Alquiladas</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1' }}>{occupiedLockers}</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.8', marginTop: '10px' }}>
                  <span style={{ fontSize: '1.2rem', fontWeight: '600' }}>📦 {totalLockers}</span> Total Inventario
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #01315f 0%, #067ddb 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: 'white',
                boxShadow: '0 10px 30px rgba(1, 49, 95, 0.3)',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.9', marginBottom: '8px', fontWeight: '500' }}>🏪 Taquillas Libres</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1' }}>{totalLockers - occupiedLockers}</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.8', marginTop: '10px' }}>
                  Capacidad: <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>{((totalLockers - occupiedLockers) / totalLockers * 100).toFixed(1)}%</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #067ddb 0%, #01315f 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: 'white',
                boxShadow: '0 10px 30px rgba(6, 125, 219, 0.3)',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.9', marginBottom: '8px', fontWeight: '500' }}>📊 vs Promedio</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1' }}>
                  {(occupationPercentage - avgOccupationPercent) >= 0 ? '+' : ''}{(occupationPercentage - avgOccupationPercent).toFixed(1)}%
                </div>
                <div style={{ fontSize: '0.85rem', opacity: '0.8', marginTop: '10px' }}>
                  {occupationPercentage > avgOccupationPercent ? '📈 Por encima' : occupationPercentage < avgOccupationPercent ? '📉 Por debajo' : '➡️ Igual'} del promedio
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Season Average Metrics */}
        <div className="mb-4">
          <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '20px', color: '#01315f' }}>
            📈 Análisis de Temporada
            {avgMetrics.startDate && avgMetrics.endDate && (
              <small style={{ fontSize: '0.85rem', fontWeight: '400', marginLeft: '15px', color: '#6b6b6b' }}>
                Periodo: {avgMetrics.startDate} - {avgMetrics.endDate}
              </small>
            )}
          </h3>
          <div className="row">
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #f3f3f3 0%, #e0e0e0 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: '#01315f',
                boxShadow: '0 10px 30px rgba(1, 49, 95, 0.15)',
                border: '1px solid #067ddb',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.8', marginBottom: '8px', fontWeight: '600', color: '#6b6b6b' }}>📊 Ocupación Promedio</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1', color: '#01315f' }}>{avgOccupationPercent}%</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.7', marginTop: '10px', color: '#6b6b6b' }}>Media de la temporada</div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #f3f3f3 0%, #e0e0e0 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: '#01315f',
                boxShadow: '0 10px 30px rgba(6, 125, 219, 0.15)',
                border: '1px solid #067ddb',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.8', marginBottom: '8px', fontWeight: '600', color: '#6b6b6b' }}>📅 Promedio Diario</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1', color: '#067ddb' }}>{avgDailyRented}</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.7', marginTop: '10px', color: '#6b6b6b' }}>Taquillas/día</div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #f3f3f3 0%, #e0e0e0 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: '#01315f',
                boxShadow: '0 10px 30px rgba(1, 49, 95, 0.15)',
                border: '1px solid #067ddb',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.8', marginBottom: '8px', fontWeight: '600', color: '#6b6b6b' }}>🗓️ Días Analizados</div>
                <div style={{ fontSize: '3rem', fontWeight: '700', lineHeight: '1', color: '#01315f' }}>{numberOfDays}</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.7', marginTop: '10px', color: '#6b6b6b' }}>Días con actividad</div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <div style={{
                background: 'linear-gradient(135deg, #f3f3f3 0%, #e0e0e0 100%)',
                borderRadius: '15px',
                padding: '25px',
                color: '#01315f',
                boxShadow: '0 10px 30px rgba(6, 125, 219, 0.15)',
                border: '1px solid #067ddb',
              }}>
                <div style={{ fontSize: '0.9rem', opacity: '0.8', marginBottom: '8px', fontWeight: '600', color: '#6b6b6b' }}>🔥 Día Pico</div>
                <div style={{ fontSize: '2.5rem', fontWeight: '700', lineHeight: '1', color: '#067ddb' }}>{peakDayRented.toLocaleString()}</div>
                <div style={{ fontSize: '0.85rem', opacity: '0.7', marginTop: '10px', color: '#6b6b6b' }}>{peakDay || 'Sin datos'}</div>
              </div>
            </div>
          </div>
        </div>
        {/* Charts Section */}
        <div className="mb-4">
          <div style={{
            background: 'white',
            borderRadius: '15px',
            padding: '30px',
            boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
          }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '0', color: '#01315f' }}>
                📊 Evolución Temporal de Ocupación
              </h3>
              <div className="d-flex align-items-center">
                <div className="btn-group mr-3" role="group">
                  <button 
                    type="button" 
                    className="btn"
                    onClick={() => this.setState({ chartView: 'type' })}
                    style={{ 
                      fontSize: '0.9rem', 
                      padding: '8px 16px',
                      backgroundColor: this.state.chartView === 'type' ? '#01315f' : 'white',
                      color: this.state.chartView === 'type' ? 'white' : '#01315f',
                      border: '2px solid #01315f'
                    }}
                  >
                    Por Tipo
                  </button>
                  <button 
                    type="button" 
                    className="btn"
                    onClick={() => this.setState({ chartView: 'zone' })}
                    style={{ 
                      fontSize: '0.9rem', 
                      padding: '8px 16px',
                      backgroundColor: this.state.chartView === 'zone' ? '#01315f' : 'white',
                      color: this.state.chartView === 'zone' ? 'white' : '#01315f',
                      border: '2px solid #01315f'
                    }}
                  >
                    Por Zona
                  </button>
                  <button 
                    type="button" 
                    className="btn"
                    onClick={() => this.setState({ chartView: 'lockerType' })}
                    style={{ 
                      fontSize: '0.9rem', 
                      padding: '8px 16px',
                      backgroundColor: this.state.chartView === 'lockerType' ? '#01315f' : 'white',
                      color: this.state.chartView === 'lockerType' ? 'white' : '#01315f',
                      border: '2px solid #01315f'
                    }}
                  >
                    Por Tipo Taquilla
                  </button>
                </div>
                <div className="btn-group" role="group">
                  <button 
                    type="button" 
                    className="btn btn-sm"
                    onClick={() => this.setState({ chartScaleMode: 'auto' })}
                    title="Ajusta la escala automáticamente según los datos"
                    style={{
                      backgroundColor: this.state.chartScaleMode === 'auto' ? '#067ddb' : 'white',
                      color: this.state.chartScaleMode === 'auto' ? 'white' : '#067ddb',
                      border: '2px solid #067ddb'
                    }}
                  >
                    📏 Auto
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-sm"
                    onClick={() => this.setState({ chartScaleMode: 'full' })}
                    title="Muestra escala completa hasta el total de taquillas"
                    style={{
                      backgroundColor: this.state.chartScaleMode === 'full' ? '#067ddb' : 'white',
                      color: this.state.chartScaleMode === 'full' ? 'white' : '#067ddb',
                      border: '2px solid #067ddb'
                    }}
                  >
                    📐 Completa
                  </button>
                </div>
              </div>
            </div>
            <div id="canvas-container">
              {this.state.chartView === 'type' && this.renderChart()}
              {this.state.chartView === 'zone' && this.renderChartByZone()}
              {this.state.chartView === 'lockerType' && this.renderChartByLockerType()}
            </div>
          </div>
        </div>

        {/* Zones Section */}
        <div className="mb-4">
          <div style={{
            background: 'white',
            borderRadius: '15px',
            padding: '30px',
            boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
          }}>
            <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '20px', color: '#01315f' }}>
              🗺️ Ocupación por Zona
            </h3>
            {this.renderZonesTable(matrixs, machines)}
          </div>
        </div>

        {/* Locker Types Section */}
        <div className="row">
          <div className="col-md-6 mb-4">
            <div style={{
              background: 'white',
              borderRadius: '15px',
              padding: '30px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
              height: '100%',
            }}>
              <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '20px', color: '#01315f' }}>
                🔑 Por Tipo de Taquilla
                <span style={{ fontSize: '0.9rem', fontWeight: '400', marginLeft: '10px', color: '#067ddb' }}>Hoy</span>
              </h3>
              {this.renderTable(matrixs)}
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div style={{
              background: 'white',
              borderRadius: '15px',
              padding: '30px',
              boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
              height: '100%',
            }}>
              <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '20px', color: '#01315f' }}>
                🔑 Por Tipo de Taquilla
                <span style={{ fontSize: '0.9rem', fontWeight: '400', marginLeft: '10px', color: '#067ddb' }}>Temporada</span>
              </h3>
              {this.renderLockerTypesByRentals()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  matrixs: state.matrixs.matrixs,
  loading: state.matrixs.loading,
  error: state.matrixs.error,
  role: state.auth.role,
  id: state.auth.id,
  type: state.auth.type,
  category: state.auth.category,
  rentals: state.rentals.rentals,
  machines: state.machines.machines,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchCustomerPDA: bindActionCreators(fetchCustomerPDA, dispatch),
  fetchRentals: bindActionCreators(fetchRentals, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OcupationDetailedView);
